import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import OutputDataTable from './output-data-table';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: whitesmoke;
  padding: 12px;
  margin: 4px;
`;

const OutputData: React.FC = () => {
  return (
    <Wrapper>
      <Typography variant="h6">Output Sample Data</Typography>
      <OutputDataTable />
    </Wrapper>
  );
};

export default OutputData;
